export default {
  INTEGER: 'INTEGER',
  STRING: 'STRING',
  ENUM: 'ENUM',
  DATE: 'DATE',
  DATERANGE: 'DATERANGE',
  NULL: 'NULL',
}
